import { SvgIcon, SvgIconProps } from '@mui/material';

export const ProductDiscountIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 26 26' fill='none'>
        <path
          d='M6.5 2.16309L3.25 6.49642V21.6631C3.25 22.2377 3.47827 22.7888 3.8846 23.1951C4.29093 23.6015 4.84203 23.8298 5.41667 23.8298H20.5833C21.158 23.8298 21.7091 23.6015 22.1154 23.1951C22.5217 22.7888 22.75 22.2377 22.75 21.6631V6.49642L19.5 2.16309H6.5Z'
          stroke='currentColor'
          strokeWidth='2.025'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M3.25 6.5H22.75'
          stroke='currentColor'
          strokeWidth='2.025'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path d='M15.9152 12.083L10.083 17.9152' stroke='currentColor' strokeWidth='2' strokeLinecap='round' />
        <path
          d='M9.66618 12.4993C9.20677 12.4993 8.83301 12.1256 8.83301 11.6662C8.83301 11.2068 9.20677 10.833 9.66618 10.833C10.1256 10.833 10.4993 11.2068 10.4993 11.6662C10.4993 12.1256 10.1256 12.4993 9.66618 12.4993Z'
          fill='currentColor'
        />
        <path
          d='M9.66634 10C10.5866 10 11.3327 10.7461 11.3327 11.6663C11.3327 12.5866 10.5866 13.3327 9.66634 13.3327C8.74605 13.3327 8 12.5866 8 11.6663C8 10.7461 8.74605 10 9.66634 10Z'
          fill='currentColor'
        />
        <path
          d='M16.3322 19.1644C15.8728 19.1644 15.499 18.7906 15.499 18.3312C15.499 17.8718 15.8728 17.498 16.3322 17.498C16.7916 17.498 17.1654 17.8718 17.1654 18.3312C17.1654 18.7906 16.7916 19.1644 16.3322 19.1644Z'
          fill='currentColor'
        />
        <path
          d='M16.3324 16.6641C17.2526 16.6641 17.9987 17.4101 17.9987 18.3304C17.9987 19.2507 17.2526 19.9967 16.3324 19.9967C15.4121 19.9967 14.666 19.2507 14.666 18.3304C14.666 17.4101 15.4121 16.6641 16.3324 16.6641Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
};
